import React from 'react';
import styled from 'styled-components';
import { UserMessage } from '@/features/ai-agents/components/user-message';
import { AiChatMessage } from '@/features/ai-agents/shared/models';
import { useChatSession } from '@/features/ai-agents/chat/context';
import { AgentMessage } from '@/features/ai-agents/components/agent-message';

export interface ChatMessagesProps {
  showReasoning?: boolean;
  showTools?: boolean;

  isLocalHost?: boolean;
}

export function ChatMessages({ showTools, showReasoning }: ChatMessagesProps) {
  const { scrollRef, messages, processedEvents, isProcessing } =
    useChatSession();

  return (
    <Wrapper ref={scrollRef}>
      {messages?.value?.map((msg, index) => {
        const isLatestAndProcessing =
          isProcessing.value && index === messages.value.length - 1;
        return msg.role === `user` ? (
          <UserMessage key={messageKey(msg, index)} message={msg} />
        ) : (
          <AgentMessage
            key={messageKey(msg, index)}
            message={msg}
            showReasoning={showReasoning}
            showTools={showTools}
            isProcessing={isProcessing}
            processedEvents={
              isLatestAndProcessing ? processedEvents : undefined
            }
          />
        );
      })}
    </Wrapper>
  );
}

export function messageKey(message: AiChatMessage, index: number): string {
  return `${message.role}-${message.created_at}-${index}`;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4rem;
  width: 100%;
  overflow-y: scroll;
  max-height: 98vh;
  padding-top: 3rem;
  padding-bottom: 20rem;

  mask-image: linear-gradient(
    var(--mask-direction, to bottom),
    hsl(0 0% 0% / 0),
    rgb(248 249 251 / 1) 5%,
    rgb(248 249 251 / 1) 85%,
    hsl(0 0% 0% / 0)
  );
`;
